/* Chargement différé des images et affiches sous la ligne de flottaison (20/10 : vitesse
   du site sans toucher à la qualité des médias). Les balises portent data-wh-src /
   data-wh-srcset (img, source d'un picture) ou data-wh-poster (video). Quand un élément
   approche de l'écran (600 px), toute sa section est chargée d'un coup : pas d'image
   qui apparaît en retard dans un carrousel. */
(function () {
  var SEL = "img[data-wh-src], img[data-wh-srcset], video[data-wh-poster]";

  function poser(el, attribut, propriete) {
    var v = el.getAttribute(attribut);
    if (v === null) return;
    el.setAttribute(propriete, v);
    el.removeAttribute(attribut);
  }

  function charger(el) {
    var parent = el.parentElement;
    if (parent && parent.tagName === "PICTURE") {
      Array.prototype.forEach.call(parent.querySelectorAll("source[data-wh-srcset]"), function (s) {
        poser(s, "data-wh-srcset", "srcset");
      });
    }
    poser(el, "data-wh-srcset", "srcset");
    poser(el, "data-wh-src", "src");
    poser(el, "data-wh-poster", "poster");
  }

  var obs = null;

  function chargerLot(el) {
    var lot = el.closest(".shopify-section") || el.parentElement || el;
    Array.prototype.forEach.call(lot.querySelectorAll(SEL), function (x) {
      if (obs) obs.unobserve(x);
      charger(x);
    });
    if (el.matches && el.matches(SEL)) charger(el);
  }

  function surveiller(racine) {
    var els = racine.querySelectorAll(SEL);
    if (!obs) {
      Array.prototype.forEach.call(els, charger);
      return;
    }
    Array.prototype.forEach.call(els, function (el) { obs.observe(el); });
  }

  if ("IntersectionObserver" in window) {
    obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) chargerLot(e.target); });
    }, { rootMargin: "600px 0px" });
  }

  function demarrer() { surveiller(document); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
  document.addEventListener("shopify:section:load", function (e) { surveiller(e.target); });
})();
